"use client";

import Image, { ImageProps } from "next/image";
import { useState } from "react";

type SafeImageProps = ImageProps & {
  fallback?: string;
};

export function SafeImage({ src, fallback = "/images/blank-white.webp", alt, ...props }: SafeImageProps) {
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <Image
      {...props}
      src={imgSrc || fallback}
      alt={alt}
      onLoadingComplete={(img) => {
        if (img.naturalWidth === 0) {
          setImgSrc(fallback);
        }
      }}
      onError={() => {
        if (imgSrc !== fallback) setImgSrc(fallback);
      }}
    />
  );
}
